<div
  class="fc-outlined-textarea"
  [class.disabled]="control.disabled"
  [class.invalid]="control.touched && control.invalid"
>
  <div class="fc-outlined-textarea__infix" [class.float-label]="control.value">
    <label class="fc-outlined-textarea__infix-label"> {{ label }}<span *ngIf="required">*</span> </label>

    <textarea
      #textareaElement
      class="fc-outlined-textarea__infix-textarea"
      autocomplete="off"
      [formControl]="control"
      (keyup)="$event.key === 'Enter' && control.valid && next.emit()"
    ></textarea>
    <small class="fc-outlined-textarea__infix-hint" *ngIf="hint">
      ({{ (control.value?.length || 0) + '/' + hint }})
    </small>
    <small class="fc-outlined-textarea__infix-error" *ngIf="control.touched && control.invalid">
      <ng-content></ng-content>
    </small>
  </div>
</div>
